import { ibhApiService } from '@hub/bearing-hub/common/api-service';
import type { IbhCatalogArticleMatrixResponseDto, IbhShape } from '@igus/iglidur-bearing-hub-api/src/data-contracts';

export const fetchCatalogArticlesMap = async (
  shapes: IbhShape[],
  locales: string[]
): Promise<IbhCatalogArticleMatrixResponseDto> => {
  const normalizedLocale = locales.map(locale => (locale.includes('-') ? locale.split('-')[1] : locale.toUpperCase()));

  const query = {
    shapes,
    locales: normalizedLocale,
  };
  try {
    ibhApiService.abortRequest('similarPartsLight');
    const response = await ibhApiService.catalogArticleMatrix(query);
    return response.data;
  } catch (err) {
    throw new Error(`Cannot fetch catalog articles map for given query: ${JSON.stringify(query)}`);
  }
};
